import { Background, Container, Modal, PaymentInfo } from './styles'
import QRCode from 'react-qr-code'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { AiOutlineClose, AiOutlineCopy } from 'react-icons/ai'
import { toast } from 'react-toastify'

interface ModalProps {
  setModalOpen: (value: boolean) => void
  pixNumber: string
}

export const ModalPix: React.FC<ModalProps> = ({ setModalOpen, pixNumber }) => {
  return (
    <Background>
      <Modal>
        <Container>
          <div className="CloseModal">
            <AiOutlineClose
              className="closeModalIcon"
              cursor="pointer"
              onClick={() => {
                setModalOpen(false)
              }}
            />
          </div>
          <div className="qrCodeText">
            <h4>Copie o código de pagamento ou</h4>
            <h4>escaneie o QR-Code</h4>
          </div>
          <PaymentInfo>
            <div className="qrCodeDiv">
              <div className="qrCode">
                <QRCode className="qrCodeImage" value={pixNumber} />
              </div>
            </div>
            <div className="grayDivs">
              <h4 className="pixNumber">{pixNumber}</h4>
            </div>
            <div className="grayDivs">
              <CopyToClipboard text={pixNumber}>
                <button
                  className="copyToClipboard"
                  onClick={() => toast.success('Código copiado com sucesso!')}
                >
                  <AiOutlineCopy className="copyButtonLogo" />
                  Copiar código
                </button>
              </CopyToClipboard>
            </div>
          </PaymentInfo>
          <div className="TextInstruction">
            <p>
              Em seguida, abra o App do seu banco na opção Pix e cole o código e confira os dados.
            </p>
          </div>
        </Container>
      </Modal>
    </Background>
  )
}
